import { maakClient, type QcClient } from '@qc/db';

/**
 * Wat er in de adresbalk staat op het moment dat het dashboard start, vóór de
 * client de inloggegevens eruit haalt. De link uit de herstelmail brengt je
 * hier met `type=recovery` in de hash; een verlopen link met `error_code`.
 */
const hashBijStart = typeof window === 'undefined' ? '' : window.location.hash;
/** Kwam de bezoeker via de link uit de mail "Nieuw wachtwoord"? */
export const herstelLinkBijStart = /type=recovery/.test(hashBijStart);
/** Was die link verlopen of al gebruikt? */
export const verlopenLinkBijStart = /error_code=otp_expired|error=access_denied/.test(hashBijStart);

/** De verbinding met de server. Het dashboard werkt online; offline is de kassa. */
export const supabase: QcClient = maakClient({
  url: import.meta.env['VITE_SUPABASE_URL'] ?? '',
  sleutel: import.meta.env['VITE_SUPABASE_ANON_KEY'] ?? '',
});
